<template>
  <div class="content_login">
    <div class="content_title">亚马逊帐户快速登录
      <!-- <span class="title-tip">(适用于亚马逊)</span> -->
      <span class="content_title_right">国际时间:
        <span>北京 {{China}}</span>
        <span>美东/加东 {{USAEast}}</span>
        <span>美西/加西 {{USAWest}}</span>
        <span>英法德意西 {{Europe}}</span>
        <span>日本 {{Japan}}</span>
        <span>澳洲 {{Australia}}</span>
      </span>
    </div>
    <div class="quick_login">
      <span v-for="(item, index) in nation" :key="item.id" @mousemove="moveMouse(index)" @mouseleave="leaveMouse"
            :class="{nation_select: nationIndex === index}" @click="itemClick(index)">
        <nation :content="item" class="nation_item"></nation>
      </span>
    </div>
    <div class="detail_data" v-show="bool||nationIndex!== -1">
      <span class="detail_name" v-for="(item, index) in detail" :key="item.id" @click="detailClick(index)">{{item.name}}</span>
    </div>
  </div>
</template>

<script>
  import national from "../common/national";
  import 'common/Format'

  export default {
    name: "quickLogin",
    components: {
      'nation': national
    },
    data() {
      return{
        bool: true,
        nation: [
          {
            id: 0,
            name: '美国站',
            nationPath: require('../../img/美国站.png'),
            path: 'https://www.amazon.com',
            detail:[
              {
                id: 0,
                name: '卖家后台',
                path: 'https://sellercentral.amazon.com/'
              },
              {
                id: 1,
                name: '热销榜',
                path: 'https://www.amazon.com/Best-Sellers-generic/zgbs'
              },
              {
                id: 2,
                name: '新品榜',
                path: 'https://www.amazon.com/gp/new-releases'
              },
              {
                id: 3,
                name: '收藏榜',
                path: 'https://www.amazon.com/gp/most-wished-for'
              },
              {
                id: 4,
                name: '礼物榜',
                path: 'https://www.amazon.com/gp/most-gifted'
              },
              {
                id: 5,
                name: '侵权诉讼',
                path: 'https://www.amazon.com/report/infringement'
              },
              {
                id: 6,
                name: '每日秒杀',
                path: 'https://www.amazon.com/gp/goldbox'
              },
              {
                id: 7,
                name: '广告联盟',
                path: 'https://affiliate-program.amazon.com/'
              },
              {
                id: 8,
                name: '开店助手',
                path: 'https://sellercentral.amazon.com/'
              },
            ],
          },
          {
            id: 1,
            name: '加拿大站',
            nationPath: require('../../img/加拿大站.png'),
            path: 'https://www.amazon.ca',
            detail:[
              {
                id: 0,
                name: '卖家后台',
                path: 'https://sellercentral.amazon.ca/'
              },
              {
                id: 1,
                name: '热销榜',
                path: 'https://www.amazon.ca/Best-Sellers-generic/zgbs'
              },
              {
                id: 2,
                name: '新品榜',
                path: 'https://www.amazon.ca/gp/new-releases'
              },
              {
                id: 3,
                name: '收藏榜',
                path: 'https://www.amazon.ca/gp/most-wished-for'
              },
              {
                id: 4,
                name: '礼物榜',
                path: 'https://www.amazon.ca/gp/most-gifted'
              },
              {
                id: 5,
                name: '侵权诉讼',
                path: 'https://www.amazon.ca/report/infringement'
              },
              {
                id: 6,
                name: '每日秒杀',
                path: 'https://www.amazon.ca/gp/goldbox'
              },
              {
                id: 7,
                name: '广告联盟',
                path: 'https://associates.amazon.ca'
              },
              {
                id: 8,
                name: '开店助手',
                path: 'https://gs.amazon.cn/sell.html'
              },
            ],
          },
          {
            id: 2,
            name: '英国站',
            nationPath: require('../../img/英国站.png'),
            path: 'https://www.amazon.co.uk',
            detail:[
              {
                id: 0,
                name: '卖家后台',
                path: 'https://sellercentral.amazon.co.uk/'
              },
              {
                id: 1,
                name: '热销榜',
                path: 'https://www.amazon.co.uk/Best-Sellers-generic/zgbs'
              },
              {
                id: 2,
                name: '新品榜',
                path: 'https://www.amazon.co.uk/gp/new-releases'
              },
              {
                id: 3,
                name: '收藏榜',
                path: 'https://www.amazon.co.uk/gp/most-wished-for'
              },
              {
                id: 4,
                name: '礼物榜',
                path: 'https://www.amazon.co.uk/gp/most-gifted'
              },
              {
                id: 5,
                name: '侵权诉讼',
                path: 'https://www.amazon.co.uk/report/infringement'
              },
              {
                id: 6,
                name: '每日秒杀',
                path: 'https://www.amazon.co.uk/gp/goldbox'
              },
              {
                id: 7,
                name: '广告联盟',
                path: 'https://affiliate-program.www.amazon.co.uk'
              },
              {
                id: 8,
                name: '开店助手',
                path: 'https://gs.amazon.cn/sell.html'
              },
            ],
          },
          {
            id: 3,
            name: '澳洲站',
            nationPath: require('../../img/澳洲站.png'),
            path: 'https://www.amazon.com.au',
            detail:[
              {
                id: 0,
                name: '卖家后台',
                path: 'https://sellercentral.amazon.com.au'
              },
              {
                id: 1,
                name: '热销榜',
                path: 'https://www.amazon.com.au/gp/bestsellers'
              },
              {
                id: 2,
                name: '新品榜',
                path: 'https://www.amazon.com.au/gp/new-releases'
              },
              {
                id: 3,
                name: '收藏榜',
                path: 'https://www.amazon.com.au/gp/most-wished-for'
              },
              {
                id: 4,
                name: '礼物榜',
                path: 'https://www.amazon.com.au/gp/most-gifted'
              },
              {
                id: 5,
                name: '侵权诉讼',
                path: 'https://www.amazon.com.au/report/infringement'
              },
              {
                id: 6,
                name: '每日秒杀',
                path: 'https://www.amazon.com.au/gp/goldbox'
              },
              {
                id: 7,
                name: '广告联盟',
                path: 'https://affiliate-program.www.amazon.com.au'
              },
              {
                id: 8,
                name: '开店助手',
                path: 'https://gs.amazon.cn/sell.html'
              },
            ],
          },
          {
            id: 4,
            name: '法国站',
            nationPath: require('../../img/法国站.png'),
            path: 'https://www.amazon.fr',
            detail:[
              {
                id: 0,
                name: '卖家后台',
                path: 'https://sellercentral.amazon.fr/'
              },
              {
                id: 1,
                name: '热销榜',
                path: 'https://www.amazon.fr/gp/bestsellers'
              },
              {
                id: 2,
                name: '新品榜',
                path: 'https://www.amazon.fr/gp/new-releases'
              },
              {
                id: 3,
                name: '收藏榜',
                path: 'https://www.amazon.fr/gp/most-wished-for'
              },
              {
                id: 4,
                name: '礼物榜',
                path: 'https://www.amazon.fr/gp/most-gifted'
              },
              {
                id: 5,
                name: '侵权诉讼',
                path: 'https://www.amazon.fr/report/infringement'
              },
              {
                id: 6,
                name: '每日秒杀',
                path: 'https://www.amazon.fr/gp/goldbox'
              },
              {
                id: 7,
                name: '广告联盟',
                path: 'https://partenaires.amazon.fr'
              },
              {
                id: 8,
                name: '开店助手',
                path: 'https://gs.amazon.cn/sell.html'
              },
            ],
          },
          {
            id: 5,
            name: '德国站',
            nationPath: require('../../img/德国站.png'),
            path: 'https://www.amazon.de',
            detail:[
              {
                id: 0,
                name: '卖家后台',
                path: 'https://sellercentral.amazon.de/'
              },
              {
                id: 1,
                name: '热销榜',
                path: 'https://www.amazon.de/gp/bestsellers'
              },
              {
                id: 2,
                name: '新品榜',
                path: 'https://www.amazon.de/gp/new-releases'
              },
              {
                id: 3,
                name: '收藏榜',
                path: 'https://www.amazon.de/gp/most-wished-for'
              },
              {
                id: 4,
                name: '礼物榜',
                path: 'https://www.amazon.de/gp/most-gifted'
              },
              {
                id: 5,
                name: '侵权诉讼',
                path: 'https://www.amazon.de/report/infringement'
              },
              {
                id: 6,
                name: '每日秒杀',
                path: 'https://www.amazon.de/gp/goldbox'
              },
              {
                id: 7,
                name: '广告联盟',
                path: 'https://partnernet.amazon.de'
              },
              {
                id: 8,
                name: '开店助手',
                path: 'https://gs.amazon.cn/sell.html'
              },
            ],
          },
          {
            id: 6,
            name: '意大利站',
            nationPath: require('../../img/意大利站.png'),
            path: 'https://www.amazon.it',
            detail:[
              {
                id: 0,
                name: '卖家后台',
                path: 'https://sellercentral.amazon.it/'
              },
              {
                id: 1,
                name: '热销榜',
                path: 'https://www.amazon.it/gp/bestsellers'
              },
              {
                id: 2,
                name: '新品榜',
                path: 'https://www.amazon.it/gp/new-releases'
              },
              {
                id: 3,
                name: '收藏榜',
                path: 'https://www.amazon.it/gp/most-wished-for'
              },
              {
                id: 4,
                name: '礼物榜',
                path: 'https://www.amazon.it/gp/most-gifted'
              },
              {
                id: 5,
                name: '侵权诉讼',
                path: 'https://www.amazon.it/report/infringement'
              },
              {
                id: 6,
                name: '每日秒杀',
                path: 'https://www.amazon.it/gp/goldbox'
              },
              {
                id: 7,
                name: '广告联盟',
                path: 'https://programma-affiliazione.amazon.it'
              },
              {
                id: 8,
                name: '开店助手',
                path: 'https://gs.amazon.cn/sell.html'
              },
            ],
          },
          {
            id: 7,
            name: '西班牙站',
            nationPath: require('../../img/西班牙站.png'),
            path: 'https://www.amazon.es',
            detail:[
              {
                id: 0,
                name: '卖家后台',
                path: 'https://sellercentral.amazon.es/'
              },
              {
                id: 1,
                name: '热销榜',
                path: 'https://www.amazon.es/gp/bestsellers'
              },
              {
                id: 2,
                name: '新品榜',
                path: 'https://www.amazon.es/gp/new-releases'
              },
              {
                id: 3,
                name: '收藏榜',
                path: 'https://www.amazon.es/gp/most-wished-for'
              },
              {
                id: 4,
                name: '礼物榜',
                path: 'https://www.amazon.es/gp/most-gifted'
              },
              {
                id: 5,
                name: '侵权诉讼',
                path: 'https://www.amazon.es/report/infringement'
              },
              {
                id: 6,
                name: '每日秒杀',
                path: 'https://www.amazon.es/gp/goldbox'
              },
              {
                id: 7,
                name: '广告联盟',
                path: 'https://afiliados.amazon.es'
              },
              {
                id: 8,
                name: '开店助手',
                path: 'https://gs.amazon.cn/sell.html'
              },
            ],
          },
          {
            id: 8,
            name: '日本站',
            nationPath: require('../../img/日本站.png'),
            path: 'https://www.amazon.co.jp',
            detail:[
              {
                id: 0,
                name: '卖家后台',
                path: 'https://sellercentral.amazon.co.jp/'
              },
              {
                id: 1,
                name: '热销榜',
                path: 'https://www.amazon.co.jp/-/en/gp/bestsellers'
              },
              {
                id: 2,
                name: '新品榜',
                path: 'https://www.amazon.co.jp/-/en/gp/new-releases'
              },
              {
                id: 3,
                name: '收藏榜',
                path: 'https://www.amazon.co.jp/-/en/gp/most-wished-for'
              },
              {
                id: 4,
                name: '礼物榜',
                path: 'https://www.amazon.co.jp/-/en/gp/most-gifted'
              },
              {
                id: 5,
                name: '侵权诉讼',
                path: 'https://www.amazon.co.jp/-/en/report/infringement'
              },
              {
                id: 6,
                name: '每日秒杀',
                path: 'https://www.amazon.co.jp/-/en/gp/goldbox'
              },
              {
                id: 7,
                name: '广告联盟',
                path: 'https://affiliate.amazon.co.jp'
              },
              {
                id: 8,
                name: '开店助手',
                path: 'https://gs.amazon.cn/sell.html'
              },
            ],
          },
        ],
        detail:[
          {
            id: 0,
            name: '卖家后台',
            path: 'https://sellercentral.amazon.com/'
          },
          {
            id: 1,
            name: '热销榜',
            path: 'https://www.amazon.com/Best-Sellers-generic/zgbs'
          },
          {
            id: 2,
            name: '新品榜',
            path: 'https://www.amazon.com/gp/new-releases'
          },
          {
            id: 3,
            name: '收藏榜',
            path: 'https://www.amazon.com/gp/most-wished-for'
          },
          {
            id: 4,
            name: '礼物榜',
            path: 'https://www.amazon.com/gp/most-gifted'
          },
          {
            id: 5,
            name: '侵权诉讼',
            path: 'https://www.amazon.com/report/infringement'
          },
          {
            id: 6,
            name: '每日秒杀',
            path: 'https://www.amazon.com/gp/goldbox'
          },
          {
            id: 7,
            name: '广告联盟',
            path: 'https://affiliate-program.amazon.com/'
          },
          {
            id: 8,
            name: '开店助手',
            path: 'https://sellercentral.amazon.com/'
          },
        ],
        nationIndex: 0,
        China: '',
        USAEast: '',
        USAWest: '',
        Europe: '',
        Japan: '',
        Australia: '',
      }
    },
    methods: {
      // 鼠标移动至国旗
      moveMouse(index){
        this.bool = true
        this.nationIndex = index
      },
      // 鼠标离开国旗
      leaveMouse(){
        this.bool = false
      },
      // 站点切换函数
      itemClick(index){
        this.nationIndex = index
      },
      // 站点信息的点击
      detailClick(index){
        window.open(this.nation[this.nationIndex].detail[index].path)
      },
      // 获取各时区时间
      getLocalTime(i) {
        //参数i为时区值数字，比如北京为东八区则输进8,西5输入-5
        if (typeof i !== 'number') return;
        let d = new Date();
        //得到1970年一月一日到现在的秒数
        let len = d.getTime();
        //本地时间与GMT时间的时间偏移差
        let offset = d.getTimezoneOffset() * 60000;
        //得到现在的格林尼治时间
        let utcTime = len + offset;
        return new Date(utcTime + 3600000 * i);
      }
    },
    mounted() {
      let _this = this; // 声明一个变量指向Vue实例this，保证作用域一致
      this.chinaTimer = setInterval(() => {
        _this.China = _this.getLocalTime(8).Format('MM-dd hh:mm:ss'); // 修改数据date
        _this.USAEast = _this.getLocalTime(-5).Format('MM-dd hh:mm:ss'); // 修改数据date
        _this.USAWest = _this.getLocalTime(-8).Format('MM-dd hh:mm:ss'); // 修改数据date
        _this.Europe = _this.getLocalTime(1).Format('MM-dd hh:mm:ss'); // 修改数据date
        _this.Japan = _this.getLocalTime(9).Format('MM-dd hh:mm:ss'); // 修改数据date
        _this.Australia = _this.getLocalTime(11).Format('MM-dd hh:mm:ss'); // 修改数据date
      }, 1000)
    },
    beforeDestroy() {
      if (this.chinaTimer) {
        clearInterval(this.chinaTimer); // 在Vue实例销毁前，清除我们的定时器
      }
    },

  }
</script>

<style scoped>
  .content_login{
    text-align: justify;
    justify-content: center;
    background-color: white;
    margin: 0 auto;
    width: 70%;
  }

  .content_title{
    color: #000;
    text-align: start;
    font-weight: bold;
    border-bottom: 1px solid #f1f4f9;
  }

  .content_title:after{
    content:'';
    display: block;
    border-bottom:5px solid #ff7f17;
  }

  .content_title_right{
    float: right;
    font-weight: 400;
    color: #7f7f7f;
  }

  .quick_login{
    display: flex;
    justify-content: center;
    padding: 10px 0 0;
    margin: 0 auto;
  }

  .nation_item{
    flex: 1;
  }

  .title-tip{
    color: #19ACFD;
  }

  .detail_data{
    display: flex;
    justify-content: center;
    font-weight: bold;
    margin: 0 auto;
  }

  .detail_name{
    background-color: #fffacf;
    font-weight: 600;
    flex: 1;
    text-align: center;
  }

  .detail_name:hover{
    opacity: .8;
    cursor: pointer;
  }

  .nation_select{
    background-color: #fffacf;
  }

  @media screen and (max-width: 1600px) {
    .content_login{
      border-radius: 1rem;
    }

    .content_title{
      margin: 10px 1rem 0;
      font-size: 1.7rem;
      min-width: 15rem;
    }

    .content_title:after{
      width: 1.8rem;
      margin-left: 7rem;
    }

    .content_title_right{
      font-size: 0.8rem;
    }

    .content_title_right span{
      margin: 0 0.8rem;
    }

    .quick_login{
      width: 108rem;
    }

    .detail_data{
      font-size: 1.2rem;
      width: 108rem;
    }

    .detail_name{
      padding: 2rem 0;
      font-size: 1.4rem;
    }

    .title-tip{
      font-size: 1.7rem;
    }
  }

  @media screen and (min-width: 1600px){
    .content_login{
      border-radius: 10px;
    }

    .content_title{
      margin: 10px 30px 0;
      font-size: 25px;
      min-width: 150px;
    }

    .content_title:after{
      width: 20px;
      margin-left: 100px;
    }

    .content_title_right{
      font-size: 14px;
    }

    .content_title_right span{
      margin: 0 10px;
    }

    .quick_login{
      width: 1440px;
    }

    .detail_data{
      font-size: 16px;
      width: 1440px;
    }

    .detail_name{
      padding: 25px 0;
    }

    .title-tip{
      font-size: 20px;
    }
  }
</style>
